const initState = {
  sportRequests: [],
  lastDocumentSportRequest: "",
  HasMoreSportRequests: true,
};

const requestedSportsReducers = (state = initState, action) => {
  switch (action.type) {
    case "ADD_SPORT_REQUEST":
      return {
        ...state,
        sportRequests: [action.payload, ...state.sportRequests],
      };
    case "GET_SPORT_REQUEST":
      return {
        ...state,
        sportRequests: action.payload.data,
        lastDocumentSportRequest: action.payload.lastDocument,
        HasMoreSportRequests: action.payload.hasMoreDocument,
      };
    case "MORE_GET_SPORT_REQUEST":
      return {
        ...state,
        sportRequests: [...state.sportRequests, ...action.payload.data],
        lastDocumentSportRequest: action.payload.lastDocument,
        HasMoreSportRequests: action.payload.hasMoreDocument,
      };
    default:
      return {
        ...state,
      };
  }
};
export default requestedSportsReducers;
